var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.model.id)?_c('b-button',{attrs:{"block":"","variant":"danger"},on:{"click":_vm.callDelete}},[_vm._v(" Eliminar ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }